"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Tab_1 = __importDefault(require("@material-ui/core/Tab"));
var Tab = function (_a) {
    var classes = _a.classes, label = _a.label, value = _a.value, _b = _a.disableFocusRipple, disableFocusRipple = _b === void 0 ? false : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, disableRipple = _a.disableRipple, _d = _a.icon, icon = _d === void 0 ? '' : _d, _e = _a.wrapped, wrapped = _e === void 0 ? false : _e, ownProps = __rest(_a, ["classes", "label", "value", "disableFocusRipple", "disabled", "disableRipple", "icon", "wrapped"]);
    return (react_1.default.createElement(Tab_1.default, __assign({}, ownProps, { classes: classes, disableFocusRipple: disableFocusRipple, disabled: disabled, disableRipple: disableRipple, icon: icon, label: label, value: value, wrapped: wrapped })));
};
exports.default = Tab;
